<template>
  <v-container mt-1>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <h2>Verify your sign-in</h2>
              <p v-if="maskedEmail">
                We sent a 6-digit code to <strong>{{ maskedEmail }}</strong>.
                Enter it below to continue. The code expires in
                {{ Math.round(mfaExpiresIn / 60) }} minute(s).
              </p>
              <form @submit.prevent="onSubmit">
                <v-text-field
                  v-model="code"
                  label="6-digit code"
                  maxlength="6"
                  required
                  autofocus
                ></v-text-field>
                <v-alert v-if="mfaError" :value="true" color="error" outline icon="warning">
                  {{ mfaError }}
                </v-alert>
                <v-layout row>
                  <v-flex xs6>
                    <v-btn
                      type="submit"
                      color="primary"
                      :disabled="submittingMfa || code.length !== 6"
                    >
                      Verify
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 text-xs-right>
                    <v-btn flat small @click="onResend" :disabled="submittingMfa">
                      Resend code
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import router from '@/router'

export default {
  name: 'mfa-code',
  data() {
    return {
      code: ''
    }
  },
  computed: {
    ...mapGetters('mfa', ['mfaPending', 'maskedEmail', 'submittingMfa', 'mfaError', 'mfaExpiresIn'])
  },
  created() {
    if (!this.mfaPending) {
      router.replace('/login')
    }
  },
  methods: {
    ...mapActions('mfa', ['verify', 'resend']),
    async onSubmit() {
      const ok = await this.verify({ code: this.code })
      if (ok) router.push('/')
    },
    async onResend() {
      this.code = ''
      await this.resend()
    }
  }
}
</script>
